/**
 * Some top-level header menu items (e.g. "Water Filter System", "Water Dispenser")
 * exist only to reveal their mega menu / dropdown on hover or focus — they are not
 * meant to navigate anywhere on click. This script stops the default navigation for
 * any menu link marked with [data-menu-no-navigate], without affecting the existing
 * hover/focus activation logic already handled by header-menu.js.
 *
 * Uses event delegation on document so it keeps working even if the menu markup is
 * re-rendered (e.g. via the Section Rendering API).
 *
 * BACFREE (Main Menu Bar): the top-level items listed in NO_NAVIGATE_TITLES below
 * behave the same way, matched by their menu title:
 * - Desktop header: clicking the title only shows the sub menu (no page change).
 * - Mobile drawer: tapping the title only expands / collapses the sub menu.
 * Sub menu links (e.g. Just Tap, ER Series) still navigate normally.
 */
const NO_NAVIGATE_TITLES = ['Indoor Water Filter System', 'Outdoor Water Filter System'];

const normalizeTitle = (element) => (element?.textContent || '').replace(/\s+/g, ' ').trim();

document.addEventListener('click', (event) => {
  const target = event.target;
  if (!(target instanceof Element)) return;

  // Existing behaviour: links explicitly marked in Liquid.
  if (target.closest('[data-menu-no-navigate]')) {
    event.preventDefault();
    return;
  }

  // Desktop header top-level link.
  const desktopLink = target.closest('a.menu-list__link');
  if (desktopLink) {
    const title = normalizeTitle(desktopLink.querySelector('.menu-list__link-title') || desktopLink);
    if (NO_NAVIGATE_TITLES.includes(title)) event.preventDefault();
    return;
  }

  // Mobile drawer top-level link inside an accordion <summary>.
  const drawerLink = target.closest('summary a.menu-drawer__menu-item-text');
  if (drawerLink && NO_NAVIGATE_TITLES.includes(normalizeTitle(drawerLink))) {
    event.preventDefault();
    const summary = drawerLink.closest('summary');
    if (summary) summary.click(); // expand / collapse the sub menu instead
  }
});